import { style } from 'typestyle';
import { important, px } from 'csx';

const planogramSimpleContainer = style({
  $debugName: 'planogram-simple',
  width: '100%',
  flexGrow: 1,
  display: 'flex',
  $nest: {
    ['.companion']: {
      display: 'flex',
      paddingTop: '10px',
      border: '1px solid #cecece',
      flexDirection: 'column',
      $nest: {
        ['.companion-list-view']: {
          flexGrow: 1,
          borderRight: 'none',
          marginRight: 0,
        },
        ['& > span']: {
          margin: 0,
          padding: '8px 10px',
          fontWeight: 'bold',
          fontSize: '.9rem',
          whiteSpace: 'nowrap',
          textAlign: 'center',
        },
      },
    },
  },
});

const planogramContainerHeader = style({
  $debugName: 'planogram-container-header',
  borderLeft: '1px solid #cecece',
  borderRight: '1px solid #cecece',
});

const planogramHeader = style({
  $debugName: 'planogram-header',
  display: 'flex',
  $nest: {
    ['& > span']: {
      marginLeft: 'auto',
      marginRight: '3em',
    },
    ['.header-date']: {
      fontWeight: 'normal',
    },
  },
});
const planogramButton = style({
  color: important('white'),
  marginRight: important(px(20)),
});
export { planogramSimpleContainer, planogramContainerHeader, planogramHeader, planogramButton };
